export const environment = {
    production: false,
    hostUrl: process.env.NG_APP_BASE_URL || "https://localhost:7101/api/"
};